<script lang="ts">
  import {page} from "$app/stores";
  import {locale} from "$lib/i18n";

  let { data } = $props();

  let url = `/${$locale}${data.url}`;
</script>

<a href={url} class:active-link={$page.url.pathname.endsWith(url)}
   class="animate-fadeIn w-28 h-20 flex flex-col gap-2.5 rounded-2xl justify-center items-center hover:bg-primary-blue/80 transition-all">
  <data.icon css="{$page.url.pathname.endsWith(url) ? 'fill-white icon-shadow' : 'text-gray-400'}" />
  <span class="text-xs md:text-sm {$page.url.pathname.endsWith(url) ? 'text-white' :'text-gray-400' }">{data.title}</span>
</a>
